import React, { useEffect, useState, useRef } from 'react';
import Head from 'next/head';
import Container from '../../atoms/Container';
import BlogListItem from '../../molecules/BlogListItem';
import Footer from '../../organisms/Footer';
import Header from '../../organisms/Header';
import Styles from './BlogList.css';
import RedButton from '../../atoms/RedButton';
import ScrollTopButton from '../../atoms/ScrollTopButton';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import BlogListBanner from '@/components/organisms/BlogListBanner';
import clsx from 'clsx';

const maxItemsDesktop = 9;
const maxItemsMobile = 6;

function BlogList({ posts, categories }) {
  const [category, setCategory] = useState(0);
  const [filtered, setFiltered] = useState([]);
  const [insets, setInsets] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(true);

  const calcInsets = (arr = []) => {
    if (typeof window === 'undefined') return 0;
    const width = window.innerWidth;
    if (width < 1200) return 0;
    const total = arr.length || 0;
    const mod = total % 3;
    return Math.abs(3 - mod);
  };

  const insertInsets = (count = 0) => {
    const items = [];
    for (let index = 0; index < count; index++) {
      items.push({ id: index });
    }
    setInsets(items);
  };

  useEffect(() => {
    setPage(1);
    setFiltered([]);
  }, [category]);

  useEffect(() => {
    let itemsToRender = [];
    if (!category || category === 0) {
      itemsToRender = posts;
    } else {
      itemsToRender = posts.filter((p) => p.idcategorie === category);
    }

    let max = maxItemsMobile;
    if (!typeof window === 'undefined') {
      const isMobile = window.innerWidth < 992;
      max = isMobile ? maxItemsMobile : maxItemsDesktop;
    }
    let paginated = itemsToRender.slice(max * (page - 1), max * page);
    setFiltered((f) => [...f, ...paginated]);
  }, [categories, posts, category, page]);

  useEffect(() => {
    insertInsets(calcInsets(filtered));

    let itemsToRender = [];
    if (!category || category === 0) {
      itemsToRender = posts;
    } else {
      itemsToRender = posts.filter((p) => p.idcategorie === category);
    }

    setHasNext(!(filtered.length === itemsToRender.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtered]);

  const categoryRefs = useRef({});

  const handleSelectCategory = (id) => {
    setCategory(id);
    const el = categoryRefs.current[id];
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  };

  return (
    <>
      <Head>
        <title>Conheça nosso blog | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Confira no blog da Santander Financiamentos dicas práticas sobre crédito, boletos e empréstimos para veículos. Facilite suas decisões com mais segurança."
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/blog.html"
        />
        <meta name="robots" content="index,follow" />
        <meta
          name="keywords"
          content="santander finaciamentos, financiamento santander, santander financiamento, Financiamento de veículos, gerar boletos, segunda via de boleto, Financiamento de pesados, Financiamento de motos, Financiamento de carros, empréstimo com garantia de veículo, Financiar veículo particular, leilão de veiculos, Financie seu carro ou moto elétrica, Economize na sua conta de energia, como funciona a energia solar, energia solar"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Conheça nosso blog | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/blog.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Confira no blog da Santander Financiamentos dicas práticas sobre crédito, boletos e empréstimos para veículos. Facilite suas decisões com mais segurança."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/blog/hero/hero-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Conheça nosso blog | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Confira no blog da Santander Financiamentos dicas práticas sobre crédito, boletos e empréstimos para veículos. Facilite suas decisões com mais segurança."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/blog.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/blog/hero/hero-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher concentrada em computador em seu escritório pesquisando sobre temas de produtos, segurança, serviços, educação financeira e sustentabilidade no blog da Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 />
      {/* <section id="blog-list-title">
        <Container>
          <h1>Blog Santander Financiamentos</h1>
        </Container>
      </section> */}
      <BlogListBanner />

      <ScrollTopButton />

      <section id="blog-list-categories">
        <ContainerHome24>
          {categories.map((cat) => {
            return (
              <div
                ref={(el) => (categoryRefs.current[cat.id] = el)}
                className={clsx(cat.id === category ? 'selected' : '', `categories-item-${cat.id}`)}
                key={`categories-item-${cat.id}`}
                onClick={(ev) => {
                  ev.preventDefault();
                  setCategory(cat.id);
                  handleSelectCategory(cat.id);
                }}
              >
                <span>{cat.name}</span>
              </div>
            );
          })}
        </ContainerHome24>
      </section>

      <section id="blog-list-posts">
        <ContainerHome24>
          {filtered.map((post) => {
            return (
              <React.Fragment key={`blog-post-item-${post.slug}`}>
                <BlogListItem post={post} categories={categories} />
              </React.Fragment>
            );
          })}

          {insets.map((i) => {
            return (
              <React.Fragment key={`blog-post-inset-${i.id}`}>
                <BlogListItem inset />
              </React.Fragment>
            );
          })}
        </ContainerHome24>
      </section>

      {hasNext && (
        <section>
          <ContainerHome24>
            <RedButton
              isButton
              className="vejamaispostagens"
              onClick={(ev) => {
                ev.preventDefault();
                setPage((pg) => pg + 1);
              }}
            >
              Ver mais postagens
            </RedButton>
          </ContainerHome24>
        </section>
      )}
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogList;
